import get from 'lodash/get';

import i18n from 'shared/lib/i18n';

import {
  BUILDING_CREATE_FAILURE,
  BUILDING_CREATE_REQUESTED,
  BUILDING_CREATE_SUCCEEDED,
  BUILDING_DELETE_FAILURE,
  BUILDING_DELETE_REQUEST,
  BUILDING_DELETE_SUCCESS,
  BUILDING_LIST_REQUESTED,
  BUILDING_REQUESTED,
  BUILDING_RESIDENTS_REQUESTED,
  BUILDING_STAFF_REQUESTED,
  BUILDING_UNITS_FAILURE,
  BUILDING_UNITS_REQUEST,
  BUILDING_UNITS_SUCCESS,
  BUILDING_UPDATE_FAILURE,
  BUILDING_UPDATE_REQUESTED,
  BUILDING_UPDATE_SUCCEEDED,
  GET_BMX_ACCESS_TOKEN_FAILURE,
  GET_BMX_ACCESS_TOKEN_REQUEST,
  GET_BMX_ACCESS_TOKEN_SUCCESS,
  GET_BUILDINGS_LIST_FAILURE,
  GET_BUILDINGS_LIST_REQUEST,
  GET_BUILDINGS_LIST_SUCCESS,
  GET_BUILDING_RESIDENTS_FAILURE,
  GET_BUILDING_RESIDENTS_REQUEST,
  GET_BUILDING_RESIDENTS_SUCCESS,
  GET_BUILDING_RESIDENT_FAILURE,
  GET_BUILDING_RESIDENT_REQUEST,
  GET_BUILDING_RESIDENT_SUCCESS,
  GET_BUILDING_STAFF_FAILURE,
  GET_BUILDING_STAFF_REQUEST,
  GET_BUILDING_STAFF_SUCCESS,
  GET_DOORS_OPENING_LOG_FAILURE,
  GET_DOORS_OPENING_LOG_REQUEST,
  GET_DOORS_OPENING_LOG_SUCCESS,
  GET_ITEMS_FOR_EXPORT_SUCCESS,
  GET_PEOPLE_IN_BUILDING_FAILURE,
  GET_PEOPLE_IN_BUILDING_SUCCESS,
  PIN_BUILDING,
  SEND_BMX_STATUS_FAILURE,
  SEND_BMX_STATUS_REQUEST,
  SEND_BMX_STATUS_SUCCESS,
  SET_MODAL_TYPE,
  SYNC_BMX_DOORS_FAILURE,
  SYNC_BMX_DOORS_REQUEST,
  SYNC_BMX_DOORS_SUCCESS,
  UNPIN_BUILDING,
} from '../../actionConstants';

import apiClient from '../../apiClient';
import { history } from '../../store';
import { CONFIRM } from '../Modal/modalTypes';

// used for all building filters
export const getBuildingsForFilter = (dispatch, queryParams) => {
  const { withReset, ...params } = queryParams || {};
  return dispatch({
    type: BUILDING_LIST_REQUESTED,
    withReset,
    payload: apiClient.building
      .getBuildingsForFilter(params)
      .then((res) => res),
  });
};

// same as `getBuildingsForFilter`
// + address info
// - `propertyLevel`
export const getAllBuildings = (dispatch) =>
  dispatch({
    type: BUILDING_LIST_REQUESTED,
    payload: apiClient.building.allWithoutPagination(),
  });

// used in building list only due to pagination
export const getBuildingsList = (dispatch, queryParams, isExport) =>
  dispatch({
    type: GET_BUILDINGS_LIST_REQUEST,
    withoutLoading: isExport,
    payload: apiClient.building.all(queryParams).then(
      (res) => {
        dispatch({
          type: isExport
            ? GET_ITEMS_FOR_EXPORT_SUCCESS
            : GET_BUILDINGS_LIST_SUCCESS,
          res,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_BUILDINGS_LIST_FAILURE,
          err,
        }),
    ),
  });

export const getBuildingUnits = (
  dispatch,
  params = {},
  buildingId,
  isExport,
) => {
  const queryParams = { ...params, disable_pagination: true };
  return dispatch({
    type: BUILDING_UNITS_REQUEST,
    withoutLoading: isExport,
    payload: apiClient.unit.all(queryParams, buildingId).then(
      (res) => {
        dispatch({
          type: isExport
            ? GET_ITEMS_FOR_EXPORT_SUCCESS
            : BUILDING_UNITS_SUCCESS,
          res,
          buildingId,
        });
        return { data: { results: res?.data } };
      },
      (err) => {
        dispatch({ type: BUILDING_UNITS_FAILURE, err });
        return err;
      },
    ),
  });
};

export const getBuilding = (dispatch, buildingId, callback) =>
  dispatch({
    type: BUILDING_REQUESTED,
    payload: apiClient.building.get(buildingId),
    callback: (res) => callback && callback(res),
  });

export const getPeopleInBuilding = (dispatch, buildingId, isLightList) => {
  const staff = dispatch({
    type: BUILDING_STAFF_REQUESTED,
    buildingId,
    payload: isLightList
      ? apiClient.building.staffLightList(buildingId).then((res) => res)
      : apiClient.building
          .staffWithoutPagination(buildingId)
          .then((res) => res),
  });
  const residents = dispatch({
    type: BUILDING_RESIDENTS_REQUESTED,
    buildingId,
    payload: isLightList
      ? apiClient.building.residentsLightList(buildingId).then((res) => res)
      : apiClient.building
          .residentsWithoutPagination(buildingId)
          .then((res) => res),
  });
  Promise.all([staff, residents])
    .then((values) => {
      let people = [];
      values.forEach((res) => {
        people = [...people, ...get(res, 'data', [])];
      });
      return dispatch({
        type: GET_PEOPLE_IN_BUILDING_SUCCESS,
        buildingId,
        people,
      });
    })
    .catch((err) =>
      dispatch({
        type: GET_PEOPLE_IN_BUILDING_FAILURE,
        buildingId,
        err,
      }),
    );
};

export const createBuilding = (dispatch, data) =>
  dispatch({
    type: BUILDING_CREATE_REQUESTED,
    isForm: true,
    payload: apiClient.building.create(data).then(
      (res) => {
        dispatch({
          type: BUILDING_CREATE_SUCCEEDED,
          res,
          successMessage: i18n.t('popup.buildingCreated'),
        });
        history.goBack();
        return res;
      },
      (err) => {
        dispatch({
          type: BUILDING_CREATE_FAILURE,
          err,
        });
        return err;
      },
    ),
  });

export const updateBuilding = (dispatch, data) =>
  dispatch({
    type: BUILDING_UPDATE_REQUESTED,
    isForm: true,
    payload: apiClient.building.update(data.id, data).then(
      (res) => {
        dispatch({
          type: BUILDING_UPDATE_SUCCEEDED,
          res,
          successMessage: i18n.t('popup.buildingUpdated'),
        });
        getBuilding(dispatch, data.id);
        return res;
      },
      (err) => {
        dispatch({
          type: BUILDING_UPDATE_FAILURE,
          err,
        });
        return err;
      },
    ),
  });

export const getDoorsOpeningLog = (
  dispatch,
  queryParams,
  buildingId,
  isExport,
) =>
  dispatch({
    type: GET_DOORS_OPENING_LOG_REQUEST,
    withoutLoading: isExport,
    payload: apiClient.building
      .getDoorsOpeningLog(buildingId, queryParams)
      .then(
        (res) => {
          dispatch({
            type: isExport
              ? GET_ITEMS_FOR_EXPORT_SUCCESS
              : GET_DOORS_OPENING_LOG_SUCCESS,
            res,
            buildingId,
            queryParams,
          });
          return res;
        },
        (err) =>
          dispatch({
            type: GET_DOORS_OPENING_LOG_FAILURE,
            err,
          }),
      ),
  });

export const getBuildingStaff = (dispatch, queryParams, buildingId, isExport) =>
  dispatch({
    type: GET_BUILDING_STAFF_REQUEST,
    withoutLoading: isExport,
    payload: apiClient.building.staff(buildingId, queryParams).then(
      (res) => {
        dispatch({
          type: isExport
            ? GET_ITEMS_FOR_EXPORT_SUCCESS
            : GET_BUILDING_STAFF_SUCCESS,
          res,
          buildingId,
          queryParams,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_BUILDING_STAFF_FAILURE,
          err,
        }),
    ),
  });

export const getBuildingResidents = (
  dispatch,
  queryParams,
  buildingId,
  isExport,
  activeResidents = true,
) => {
  const type = activeResidents ? 'residents' : 'moved-out-residents';
  return dispatch({
    type: GET_BUILDING_RESIDENTS_REQUEST,
    withoutLoading: isExport,
    payload: apiClient.building.residents(buildingId, queryParams, type).then(
      (res) => {
        dispatch({
          type: isExport
            ? GET_ITEMS_FOR_EXPORT_SUCCESS
            : GET_BUILDING_RESIDENTS_SUCCESS,
          res,
          buildingId,
          queryParams,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_BUILDING_RESIDENTS_FAILURE,
          err,
        }),
    ),
  });
};

export const getBuildingResidentById = (dispatch, buildingId, residentId) =>
  dispatch({
    type: GET_BUILDING_RESIDENT_REQUEST,
    payload: apiClient.building.residentById(buildingId, residentId).then(
      (res) => {
        dispatch({
          type: GET_BUILDING_RESIDENT_SUCCESS,
          res,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_BUILDING_RESIDENT_FAILURE,
          err,
        }),
    ),
  });

export const getBuildingResidentsForExport = (
  dispatch,
  queryParams,
  buildingId,
  activeResidents = true,
) => {
  const type = activeResidents ? 'residents' : 'moved-out-residents';
  return dispatch({
    type: GET_BUILDING_RESIDENTS_REQUEST,
    withoutLoading: true,
    payload: apiClient.building
      .residentsDetailed(buildingId, queryParams, type)
      .then(
        (res) => {
          dispatch({
            type: GET_ITEMS_FOR_EXPORT_SUCCESS,
            res,
            buildingId,
            queryParams,
          });
          return res;
        },
        (err) =>
          dispatch({
            type: GET_BUILDING_RESIDENTS_FAILURE,
            err,
          }),
      ),
  });
};

export const deleteBuilding = (dispatch, buildingId, queryParams) =>
  dispatch({
    type: BUILDING_DELETE_REQUEST,
    payload: apiClient.building.delete(buildingId).then(
      () => {
        dispatch({
          type: BUILDING_DELETE_SUCCESS,
          id: buildingId,
          successMessage: i18n.t('popup.buildingRemoved'),
        });
        return getBuildingsList(dispatch, queryParams);
      },
      (err) =>
        dispatch({
          type: BUILDING_DELETE_FAILURE,
          err,
        }),
    ),
  });

export const confirmBuildingDeletion = (dispatch, building, queryParams) => {
  const modalProps = {
    bodyText: i18n.t('building.confirmRemoval', {
      buildingName: building?.name,
    }),
    onConfirm: () => deleteBuilding(dispatch, building.id, queryParams),
  };
  dispatch({
    type: SET_MODAL_TYPE,
    modalType: CONFIRM,
    modalProps,
  });
};

export const getBMXAccessToken = (dispatch, buildingId) =>
  dispatch({
    type: GET_BMX_ACCESS_TOKEN_REQUEST,
    payload: apiClient.building.getBMXAccessToken(buildingId).then(
      (res) => {
        dispatch({
          type: GET_BMX_ACCESS_TOKEN_SUCCESS,
        });
        return get(res, 'data.accessToken');
      },
      (err) =>
        dispatch({
          type: GET_BMX_ACCESS_TOKEN_FAILURE,
          err,
        }),
    ),
  });

export const syncBMXDoorsInBuilding = (dispatch, buildingId) =>
  dispatch({
    type: SYNC_BMX_DOORS_REQUEST,
    payload: apiClient.building.syncBMXDoors(buildingId).then(
      (res) =>
        dispatch({
          type: SYNC_BMX_DOORS_SUCCESS,
          res,
        }),
      (err) =>
        dispatch({
          type: SYNC_BMX_DOORS_FAILURE,
          err,
        }),
    ),
  });

export const sendBMXCameraStatus = (dispatch, buildingId, cameraId, data) =>
  dispatch({
    type: SEND_BMX_STATUS_REQUEST,
    payload: apiClient.building
      .sendBMXCameraStatus(buildingId, cameraId, data)
      .then(
        (res) =>
          dispatch({
            type: SEND_BMX_STATUS_SUCCESS,
            res,
          }),
        (err) =>
          dispatch({
            type: SEND_BMX_STATUS_FAILURE,
            err,
          }),
      ),
  });

export const pinBuilding = (dispatch, buildingId, buildingName) =>
  dispatch({ type: PIN_BUILDING, buildingId, buildingName });

export const unpinBuilding = (dispatch, buildingId) =>
  dispatch({ type: UNPIN_BUILDING, buildingId });
